// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"_dc9c2642","icon":"_ee730311","facebook":"_ab4100b2","twitter":"_a86245a7","pinterest":"_e58e31ec"};